import { createFileRoute } from '@tanstack/react-router';

import { CategoriesPage } from '@/features/catalog/CategoriesPage';

/** Дерево категорий — подчинённая страница каталога: структура, а не выборка товаров. */
export const Route = createFileRoute('/_app/catalog_/categories')({
  component: CategoriesPage,
});
